// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import InvoiceGroupEditScreen from "../../../src/screens/invoice-groups/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} InvoiceGroupEditRouteProps */

/** @typedef {Record<string, never>} InvoiceGroupEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<InvoiceGroupEditRouteProps, InvoiceGroupEditRouteState>}
 */
class InvoiceGroupEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Edit invoice group")}</ScreenTitle>
        <InvoiceGroupEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<InvoiceGroupEditRouteProps>} */
const InvoiceGroupEditRouteComponent = memo(shapeComponent(InvoiceGroupEditRoute))

export default InvoiceGroupEditRouteComponent
